import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export default function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const history = {
      push: (to, opts) => navigate(to, opts),
      replace: (to, opts) => navigate(to, { replace: true, ...(opts || {}) }),
      goBack: () => navigate(-1),
      go: (n) => navigate(n),
    };
    const match = { params };

    return (
      <Component
        {...props}
        history={history}
        location={location}
        match={match}
        router={{ navigate, location, params }}
      />
    );
  }
  ComponentWithRouterProp.displayName = `withRouter(${
    Component.displayName || Component.name || 'Component'
  })`;
  return ComponentWithRouterProp;
}
